"use strict";

const Path = require('@leverege/path');

const config = {};
/**
 * This supplies a common place where configs can be stored
 * and accessed
 */

function set(resource, key, value) {
  let r = config[resource];

  if (r == null) {
    config[resource] = {};
    r = config[resource];
  }

  Path.set(key, r, value);
}
/**
 * Returns the value for the resource at the given key, or dValue
 */


function get(resource, key, dValue) {
  const r = config[resource];

  if (r != null) {
    return Path.get(key, r, dValue);
  }

  return dValue;
}

exports.set = set;
exports.get = get;